<template>
    <div class="content-wrapper">
        <h4 class="mb-0 bold-title">{{ pageTitle }}</h4>
        <br>
        <div class="mb-primary">
            <app-tab :tabs="tabBase" 
            :active-tab="activeTab" :key="activeTab" type="horizontal" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageTitle : null,
            disable : false,
            tabsContracts: null,
            activeTab: 0
        }
    },
    computed: {
        currentTabComponent() {
            // Verifica que activeTab esté dentro del rango del array
            return this.tabsContracts[this.activeTab]?.component || null;
        },
        tabBase() {
            if (localStorage.getItem('process_add_contract')) {
                const tabs = this.tabsContracts;  
                if (!tabs) return [];
                return tabs.map((tab, index) => { 
                    const disable = index <= this.activeTab ? false : true;
                    return {
                            ...tab,
                            "disabled": disable 
                        };
                });
            }else{
                return this.tabsContracts;
            }

        }
    },
    created() {
        let documentsComponent = "form-documents";
        if (localStorage.getItem('process_view_contract')) {
            documentsComponent = 'form-documents_view';
        }
        if (localStorage.getItem('process_edit_contract')) {
            documentsComponent = "form-documents_edit";
        }

        let revisionComponent = "form-revision";
        if (localStorage.getItem('process_view_contract')) {
            revisionComponent = "form-revision_view";
        }
        
        this.tabsContracts =  [ 
                {
                    "icon": "send",
                    "name": "contract",
                    "component": "form-details",
                    "permission": "",
                },   
                {
                    "icon": "lock",
                    "name": "products",
                    "component": "form-products",
                    "permission": "",
                },
                {
                    "icon": "paperclip",
                    "name": "supplier",
                    "component": "form-suppliers",
                    "permission": "",
                },
                {
                    "icon": "shield",
                    "name": "customer",
                    "component": "form-customer",
                    "permission": "",
                },
                {
                    "icon": "file-text",
                    "name": "documents",
                    "component": documentsComponent,
                    "permission": "",
                },   
                !localStorage.getItem('process_add_contract') ?
                {
                    "icon": "bell",
                    "name": "revision",
                    "component": revisionComponent,
                    "permission": "",
                } : '',  
            ];
    },
    mounted() {
        this.updateActiveTab();  
        if (localStorage.getItem('process_add_contract')) {
            this.pageTitle = 'Add Contract';
            this.disable = true;  
        }else if(localStorage.getItem('process_edit_contract')){
            this.pageTitle = 'Edit Contract';
        }else if(localStorage.getItem('process_view_contract')){
            this.pageTitle = 'View Contract';
        }

        const dataMaster = JSON.parse(localStorage.getItem('DataContractMaster')) ;
        if (dataMaster) {
            const { contractNumber } = dataMaster;
            if (contractNumber) {
                this.pageTitle += ` - ${contractNumber}`;
            }
        }
    },
    watch: {
        $route() {
            this.updateActiveTab();
        },
        activeTab(newVal){
            console.log('El tab ha cambiado a ', newVal);
        }
    },
    methods: {
        updateActiveTab() {
            const routeName = this.$route.name;
            const tabIndex = this.tabsContracts.findIndex(tab => tab.name.toLowerCase() === routeName.toLowerCase());
            if (tabIndex !== -1) {
                this.activeTab = tabIndex;
            } 
        }
    }
}
</script>